module.exports = __webpack_public_path__ + "img/A01.045406b2.png";